// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-btn-events-disabled[data-v-057832a6]{text-transform:uppercase;opacity:1!important;margin:5px;padding:10px;font-size:11px;min-width:85px;font-weight:700}.filter-btn-events-disabled[data-v-057832a6],.filter-btn-events-disabled[data-v-057832a6]:hover{color:#007c86!important;border:2px solid #007c86!important;background-color:#e9ecef!important}", ""]);
// Exports
module.exports = exports;
